import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from 'components/forms/Button'
import Link from 'components/misc/Link'
import Header from 'components/typography/Header'
import styles from './styles/Onboarding.css'
import P from 'components/typography/Paragraph'

export const Popover = ({
  className,
  pageDisplay,
  nextOnboarding,
  prevOnboarding,
  skipOnboarding,
  header,
  content,
  learnMoreHref
}) => {
  const rootRef = useRef()
  useEffect(() => {
    const root = rootRef.current
    if (root && root.scrollIntoView) {
      root.scrollIntoView()
    }
  }, [])

  return (
    <div className={classNames(styles.popover, className)} ref={rootRef}>
      <div className={styles.topLayout}>
        <span className={styles.pageCounter}>{pageDisplay}</span>
        <div className={styles.close} onClick={() => skipOnboarding()}>Close</div>
      </div>
      <Header className={styles.header} level={4}>{header}</Header>

      {content.map((element, n) => (
        <P key={n} className={styles.bodyText}>
          {element}
        </P>
      ))}

      <div
        data-testid='bottomlayout'
        className={classNames({ [styles.bottomLayoutFull]: learnMoreHref, [styles.bottomLayoutRight]: !learnMoreHref })}
      >
        {learnMoreHref && <Link href={learnMoreHref} blue rel='noopener noreferrer' target='_blank'>Learn more</Link>}
        <div className={styles.buttons}>
          {prevOnboarding && <button className={styles.backButton} onClick={() => prevOnboarding()}>Back</button>}
          <Button color='blue' onClick={() => nextOnboarding()}>{nextOnboarding ? 'Next' : 'Ok'}</Button>
        </div>
      </div>
    </div>
  )
}

Popover.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ])
  ).isRequired,
  nextOnboarding: PropTypes.func,
  pageDisplay: PropTypes.string,
  skipOnboarding: PropTypes.func,

  prevOnboarding: PropTypes.func,
  learnMoreHref: PropTypes.string
}

export default Popover
